module.exports = __webpack_public_path__ + "static/media/iar_responder_other_selected.7016bb80.svg";